var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMk = function SvgMk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d20000",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96l224 231.43L544 0h96L0 480h96l224-231.43L544 480h96zm640 192v96L0 192v96zM280 0l40 205.714L360 0zm0 480l40-205.714L360 480z",
    fill: "#ffe600"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 77.143,
    cy: 240,
    cx: 320,
    fill: "#ffe600",
    stroke: "#d20000",
    strokeWidth: 17.143
  })));
};
export default __webpack_public_path__ + "assets/8fbf6ecea39e6f4469078da53aca835c.svg";
export { SvgMk as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/mk.svg